<template>
    <div class="page-content">
        <app-title text="Vigilancia" />
        <router-view></router-view>
        <b-modal
            id="assistance-window"
            ref="assistanceWindow"
            size="xl"
            body-bg-variant="danger"
            header-bg-variant="danger"
            footer-bg-variant="danger"
            cancel-disabled
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            header-text-variant="white"
        >
            <template slot="modal-header">
                <div class="text-white">
                    <h2 style="color: white">
                        {{
                            `${personRequiringAssistance.name} Esta solicitando asistencia`
                        }}
                    </h2>
                </div>
            </template>
            <template slot="modal-ok"
                >Confirmo que he atendido a la persona</template
            >
            <b-card no-body bg-variant="danger" text-variant="white">
                <b-row no-gutter>
                    <b-col md="4">
                        <b-img :src="personRequiringAssistance.photo"></b-img>
                    </b-col>
                    <b-col md="8">
                        <b-card-body>
                            <b-card-text>
                                <p>Una persona esta solicitando asistencia</p>
                                <p>
                                    Por favor contactela inmediatamente para
                                    asistirla
                                </p>
                                <p>
                                    <b-row>
                                        <b-col md="2">Nombre:</b-col>
                                        <b-col>{{
                                            personRequiringAssistance.name
                                        }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="2">Teléfono:</b-col>
                                        <b-col>{{
                                            personRequiringAssistance.phone ||
                                            'No tiene'
                                        }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="2">E-mail:</b-col>
                                        <b-col>{{
                                            personRequiringAssistance.email ||
                                            'No tiene'
                                        }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="2">Estructura:</b-col>
                                        <b-col>
                                            {{ structureInfo }}
                                        </b-col>
                                    </b-row>
                                </p>
                                <app-form-textarea-input
                                    v-model="assistanceNotes"
                                    label="Comentarios"
                                    @input="$v.assistanceNotes.$touch()"
                                />
                                <span
                                    v-if="$v.assistanceNotes.$error"
                                    class="local-field-error"
                                >
                                    Debe escribir la explicación de lo sucedido
                                </span>
                            </b-card-text>
                        </b-card-body>
                    </b-col>
                </b-row>
            </b-card>
            <template slot="modal-footer">
                <b-btn variant="confirm" @click="confirmAssistance"
                    >Confirmo que he asistido a la persona</b-btn
                >
            </template>
        </b-modal>

        <!-- Mensajes al puesto -->
        <b-modal
            id="service-spot-message-window"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            size="lg"
            v-if="!!serviceSpotMessageDestinatary"
        >
            <template v-slot:modal-title>
                <div>
                    {{
                        serviceSpotMessageDestinatary.service_spot_message
                            .created_by.name
                    }}
                    <span
                        v-if="
                            !!serviceSpotMessageDestinatary.service_spot_message
                                .created_by.position
                        "
                        >({{
                            serviceSpotMessageDestinatary.service_spot_message
                                .created_by.position.name
                        }})</span
                    >
                    envía un mensaje
                </div>
            </template>
            <div class="">
                <div class="mb-3">
                    <h5>
                        Asunto:
                        {{
                            serviceSpotMessageDestinatary.service_spot_message
                                .subject
                        }}
                    </h5>
                </div>
                <div
                    v-html="
                        serviceSpotMessageDestinatary.service_spot_message.message.linkify()
                    "
                ></div>
            </div>
            <div
                class="mt-3"
                v-if="
                    serviceSpotMessageDestinatary.service_spot_message
                        .require_response
                "
            >
                <b-form-group label="Respuesta:">
                    <b-form-textarea
                        v-model="serviceSpotMessage.response"
                        :state="validResponse"
                    ></b-form-textarea>
                </b-form-group>
            </div>
            <template v-slot:modal-footer>
                <b-button
                    variant="primary"
                    class="mt-3"
                    block
                    @click="acceptMessage"
                    :disabled="inProgress"
                    >Aceptar</b-button
                >
            </template>
        </b-modal>
    </div>
</template>
<script>
import Title from '../../UI/Layout/Title.vue'
import vigilanceRepository from '@repositories/vigilance.repository'
import { required } from 'vuelidate/lib/validators'
export default {
    components: {
        appTitle: Title,
    },
    name: 'vigilance-page',
    data: () => ({
        personRequiringAssistance: '',
        assistanceNotes: '',
        personEntry: '',
        serviceSpotMessage: {
            response: '',
        },
        serviceSpotMessageDestinatary: {
            service_spot_message: {
                subject: '',
                message: '',
                require_response: true,
            },
        },
        validResponse: null,
    }),
    validations: {
        assistanceNotes: { required },
    },
    computed: {
        structureInfo() {
            if (!this.personRequiringAssistance.structure) return ''

            const structure = this.personRequiringAssistance.structure
            const parts = []

            !!structure.tower && parts.push(`Torre ${structure.tower}`)
            !!structure.name && parts.push(structure.name)

            return parts.join(', ')
        },
    },
    methods: {
        async confirmAssistance() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            const vr = { ...vigilanceRepository }
            try {
                const { data } = await vr.confirmAssistance(
                    this.user.id,
                    this.personRequiringAssistance.id,
                    this.assistanceNotes
                )

                if (data.status) {
                    this.$refs.assistanceWindow.hide()
                    toastr.success(data.msg)
                    this.personRequiringAssistance = ''
                    this.assistanceNotes = ''
                    this.$v.$reset()
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al confirmar la asistencia [${err.message}]`
                )
            }
        },
        listenAlarm() {
            // Echo.private('AccessPoint.34').listen('NewAlarm')
        },
        showServiceSpotMessage(msg) {
            this.serviceSpotMessageDestinatary = msg
            this.sendDeliveryConfirmation()
            this.openModal('service-spot-message-window')
        },
        sendDeliveryConfirmation() {
            repo.post('service-spot-messages/confirm-delivery', {
                serviceSpotMessageDestinataryId: this
                    .serviceSpotMessageDestinatary.id,
                deliveredToId: this.user.id,
            })
        },
        acceptMessage() {
            if (
                this.serviceSpotMessageDestinatary.service_spot_message
                    .require_response &&
                !this.serviceSpotMessage.response
            ) {
                this.validResponse = false
                return toastr.error('Debe contestar el mensaje')
            }

            repo.post('service-spot-messages/response', {
                serviceSpotMessageDestinataryId: this
                    .serviceSpotMessageDestinatary.id,
                response: this.serviceSpotMessage.response,
                requireResponse: this.serviceSpotMessageDestinatary
                    .service_spot_message.require_response,
            })

            this.serviceSpotMessage.response = ''
            this.validResponse = null
            this.closeModal('service-spot-message-window')
        },
    },
    mounted() {
        if (
            !this.client ||
            !this.accessPoint ||
            this.user.profile.slug !== 'vigilante'
        )
            return

        const serviceSpotChannel = `Client.${this.accessPoint.client_id}.Venue.${this.accessPoint.venue_id}.AccessPoint.${this.accessPoint.id}`
        const venueChannel = `Client.${this.accessPoint.clien_id}.Venue.${this.accessPoint.venue_id}`
        const clientChannel = `Client.${this.accessPoint.client_id}`

        // Echo.private(clientChannel).listen(
        //     '.comunications.serviceSpotMessageSent',
        //     e => {
        //         this.showServiceSpotMessage(e.serviceSpotMessageDestinatary)
        //     }
        // )

        // Echo.private(venueChannel)
        //     .listen('.vigilance.assistanceRequired', e => {
        //         this.personRequiringAssistance = e.person
        //         this.$refs.assistanceWindow.show()
        //     })
        //     .listen('.vigilance.visitOverdueAlarm', p => {
        //         if (this.user.profile.slug !== 'vigilante') return

        //         const options = {
        //             closeButton: true,
        //             timeOut: 0,
        //             extendedTimeOut: 0,
        //         }
        //         toastr.error(
        //             `El visitante (${p.personEntry.visitor_type.name}) ${p.personEntry.person.name} lleva mas tiempo del permitido`,
        //             'Alarma',
        //             options
        //         )
        //     })
        //     .listen('.comunications.serviceSpotMessageSent', e => {
        //         this.showServiceSpotMessage(e.serviceSpotMessageDestinatary)
        //     })

        // Echo.private(serviceSpotChannel).listen(
        //     '.comunications.serviceSpotMessageSent',
        //     e => {
        //         this.showServiceSpotMessage(e.serviceSpotMessageDestinatary)
        //     }
        // )

        // this.openModal('service-spot-message-window')

        $(document).on('click', function (e) {
            if (e.target.className === 'linkified') {
                e.preventDefault()
                window.open(e.target.href, '_blank')
            }
        })
    },
}
</script>
<style scoped>
.local-field-error {
    color: yellow !important;
}
</style>
